





































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeContratosStore from '@/components/RemuneracaoMedica/contratos/Store/BackofficeContratosStore'

@Component
export default class ComponentModalRemoveRegra extends Vue {
  rmvrgsLoading: boolean = false

  get getBackofficeContratosStore() {
    return getModule(BackofficeContratosStore, this.$store)
  }

  get removeRegraLoading() {
    return this.rmvrgsLoading
  }

  set removeRegraLoading(value: boolean) {
    this.rmvrgsLoading = value
  }

  get removeRegraList() {
    return this.getBackofficeContratosStore.modal.removeRegraList
  }

  closeModalRemoveRegra() {
    this.getBackofficeContratosStore.clearRemoveRegraId()
    this.getBackofficeContratosStore.setShowModalRemoveRegraList(false)
  }

  async removerRegra() {
    this.removeRegraLoading = true
    await this.getBackofficeContratosStore.removeRegraById()
    this.removeRegraLoading = false
    this.closeModalRemoveRegra()
  }
}
